// @flow
import React, {useEffect, useMemo} from 'react';
import {useParams} from "react-router";
import {useTranslation} from "react-i18next";
import {PAGE_ORDERS} from "../../locales/pages/namespaces";
import useOrderAction from "../../hooks/order/useOrderAction";
import useOrderDetailsData from "../../hooks/order/useOrderDetailsData";
import {useOrderData} from "../../hooks/order/useOrderData";
import Box from "@mui/material/Box";
import {Typography} from "@mui/material";
import Overview from "../../components/app/overview/overview";
import OrderPrices from "../../components/app/orderPrices/orderPrices";
import ContentLoader from "../../components/general/contentLoader/contentLoader";
import ProductPreview from "../../components/app/productPreview/productPreview";
import './order.css'
import {OrderStatus} from "../../helpers/constants";
import useUserData from "../../hooks/user/useUserData";

type Props = {};

const Order = (props: Props) => {
	const {id} = useParams()
	const {data} = useUserData()
	const {t} = useTranslation(PAGE_ORDERS)
	const {getOrderDetails} = useOrderAction()
	const {order, rawOrder} = useOrderDetailsData(id)
	const {loading} = useOrderData()
	useEffect(() => {
		getOrderDetails(id)
	}, [getOrderDetails, id])

	const leasingCustomer = order?.leasingCustomers?.find(
		customer => String(customer.id) === String(order.SendToCustomer)
	)

	console.log('order', order)
	console.log('rawOrder', rawOrder)
	
	return order ? (
		<Box>
			<Box p={1}>
				<Typography
					pb={1}
					variant={'h2'}
					component={'div'}
					sx={{
						textAlign: 'center'
					}}
				>
					{t('Order Preview')}
				</Typography>
				<Overview order={order} finalize/>
			</Box>
			{data?.isLeasing && (
				<Box px={{ xs: 2, sm: 4 }} pb={2}>
					<Box className="leasing-details-section">
						<Typography
							pb={1.5}
							variant={'h4'}
							component={'div'}
							color={'primary'}
						>
							{t('Leasing Details')}
						</Typography>
						<Box component="dl" className="leasing-details-grid">
							{[
								{label: t('Driver name'), value: order.DriverName},
								{label: t('Driver phone'), value: order.DriverPhone},
								{label: t('Vehicle license number'), value: order.VehicleLicenseNumber},
								{label: t('Vehicle miles'), value: order.VehicleMiles},
								{label: t('Send to customer'), value: leasingCustomer?.description || '-', className: 'leasing-customer-field'}
							].map(detail => (
								<Box
									component="div"
									className={`leasing-details-item ${detail.className || ''}`}
									key={detail.label}
								>
									<Typography component="dt" className="leasing-details-label">
										{detail.label}
									</Typography>
									<Typography component="dd" className="leasing-details-value">
										{detail.value || '-'}
									</Typography>
								</Box>
							))}
						</Box>
					</Box>
				</Box>
			)}
			<Box p={4} sx={{backgroundColor: '#FFFFFF'}}>
				{rawOrder?.products && (
					rawOrder?.products?.map(product => (
						<ProductPreview
							key={`product-${product._rowKey || product.id}`}
							product={{...product}}
							orderSubmitted={order.status !== OrderStatus.InProgress}
						/>
					))
				)}
			</Box>
			<Box p={4} className={'order-info'}>
				<Box sx={{width: {xs: '100%', sm: '100%', md: '50%'}}}>
					<Typography
						pb={1}
						variant={'h4'}
						component={'div'}
					>
						{t('Notes')}
					</Typography>
					<div className={'order-notes'}>
						{order?.notes}
					</div>
				</Box>
				<Box sx={{width: {xs: '100%', sm: '100%', md: '50%'}}} pt={1}>
					<OrderPrices order={order} orderSubmitted={order.status !== OrderStatus.InProgress}/>
				</Box>
			</Box>
		</Box>
	) : (
		<ContentLoader loading={loading}/>
	)
};

export default Order